import toast from "react-hot-toast";

const  AppToast = {
    success(message: string) {
        return toast.success(message);
    },
    error(message: string) {
        return toast.error(message);
    },
    info(message: string) {
        return toast(message, {
            style: {
                border: '1px solid #713200',
                padding: '16px',
                color: '#713200',
            },
            iconTheme: {
                primary: '#713200',
                secondary: '#FFFAEE',
            },
        });
    },
    warning(message: string) {
        return toast(message, {
            style: {
                border: '1px solid #713200',
                padding: '16px',
                color: '#713200',
            },
            iconTheme: {
                primary: '#713200',
                secondary: '#FFFAEE',
            },
        });
    },
};

export {  AppToast };
